import './dropdownlist.css'

import {
    DropDownList as KendoDropDownList,
} from "@progress/kendo-react-dropdowns";
import { ChevronDownIcon } from './icons/Icons';

export default function DropDownList(
    {
        data,
        value,
        textField = "name",
        onChange,
        adaptive = false,
        adaptiveTitle = "Velg alternativ",
        disabled = false,
        hasValidationError = false,
        defaultText = "Ikke oppgitt",
        showDefault = true,
        className = "",
        filterable = false,
        onFilterChange,
        required = false,
    }
) {

    return (
        <KendoDropDownList
            data={data}
            value={value}
            textField={textField}
            onChange={handleOnChange}
            adaptive={adaptive}
            adaptiveTitle={adaptiveTitle}
            fillMode="solid"
            disabled={disabled}
            className={`p-dropdown-list font-size-lg  ${className}`}
            svgIcon={ChevronDownIcon}
            defaultItem={showDefault ? { [textField]: defaultText, notSelectable: true } : undefined}
            filterable={filterable}
            onFilterChange={handleOnFilterChange}
            required={required}
            valid={!hasValidationError}
        />
    );

    function handleOnChange(e) {
        if (Object.hasOwn(e.value, "notSelectable")) return;
        onChange(e.value);
    }
    function handleOnFilterChange(e) {
        if (typeof onFilterChange === 'function') {
            onFilterChange(e);
        }
    }
}
